import { parseListRouteSearch } from '../../hooks/use-list-table-helpers/index.js';
import type { InvoiceListSearch } from './invoice-list-search.js';
import { parseInvoiceListStatus } from './parse-invoice-list-status.js';

export function parseInvoiceListSearch(search: Record<string, unknown>): InvoiceListSearch {
  // Set even when rejected: the router spreads the raw URL search under this result.
  return { ...parseListRouteSearch(search), status: parseInvoiceListStatus(search.status) };
}
